import React from 'react';
import {Bar} from 'react-chartjs-2';
import ChartContainer from './chartContainer';
import {formatNumberToDisplayWithCommas} from '../../../../../components/common/shared';
import {getMonthlyChartLabels, getPeriodAverageValue} from '../chartLabelHelpers';
import './chartSetup';

const RevenuePerShiftChart = ({chartData}) => {
    const labels = getMonthlyChartLabels(chartData.items);
    const values = chartData.items.map(item => item.avg_revenue);
    const targetDataset = chartData.items.map(item => item.target);

    const data = {
        labels: labels,
        datasets: [
            {
                type: 'bar',
                data: values,
                backgroundColor: '#bfbfbf',
                order: 2,
                label: 'Rev Per Shift',
            },
            {
                type: 'line',
                data: targetDataset,
                backgroundColor: '#c00000',
                borderColor: '#c00000',
                order: 1,
                label: 'Target',
            }
        ],
    }

    const options = {
        scales: {
            y: {
                title: 'Revenue Per Shift',
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return `$${value}`;
                    }
                }
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                    tickLength: 10,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                }
            },
        },
        plugins: {
            legend: {
                reverse: true,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += `$${formatNumberToDisplayWithCommas(context.parsed.y, 0)}`;
                        }
                        return label;
                    }
                }
            }
        },
        maxBarThickness: 40,
    }

    const summaryItems = [
        {
            label: 'Period Avg',
            value: `$${formatNumberToDisplayWithCommas(getPeriodAverageValue(chartData), 0)}`,
        },
        {
            label: 'Current Target',
            value: `$${formatNumberToDisplayWithCommas(chartData.current_target, 0)}`,
        },
    ]

    return (
        <ChartContainer title="Revenue Per Shift" summaryItems={summaryItems}>
            <Bar data={data} options={options}/>
        </ChartContainer>
    )
}

export default RevenuePerShiftChart;
